export default "__VITE_ASSET__DFwaSUf$__"